<template>
  <div class="wrapper">
    <router-view v-if="isMobileFlag" />
    <el-container v-else>
      <el-header>
        <v-head />
      </el-header>
      <el-container>
        <el-aside :width="collapse ? '76px' : '250px'">
          <v-sidebar />
        </el-aside>
        <el-main>
          <v-tags :sidebarWidth="collapse ? '76px' : '250px'" />
          <div class="content">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :include="cachedViews">
                <router-view :key="key" />
              </keep-alive>
            </transition>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import vHead from './header.vue';
  import vSidebar from './sidebar.vue';
  import vTags from './tags.vue';
  import bus from '../common/js/bus';
  import { isMobile } from '@/utils';
  export default {
    components: {
      vHead,
      vSidebar,
      vTags,
    },
    data() {
      return {
        collapse: false,
        contentStyleObj: {
          height: '',
        },
        isMobileFlag: false,
      };
    },
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews;
      },
      key() {
        return this.$route.fullPath;
      },
    },
    created() {
      // 自动计算主体部分高度
      window.addEventListener('resize', this.getHeight);
      // 获取字典
      this.$baseRequest.getAllDictMap();
      this.getHeight();
      // 左侧菜单栏收缩
      bus.$on('collapse', (msg) => {
        this.collapse = msg;
      });
      this.isMobileFlag = isMobile();
    },
    destroyed() {
      window.removeEventListener('resize', this.getHeight);
    },
    methods: {
      getHeight() {
        this.contentStyleObj.height = window.innerHeight - 120 + 'px';
      },
    },
  };
</script>
<style lang="scss" scoped>
  .el-header {
    padding: 0px;
  }
  .el-main {
    height: calc(100vh - 60px);
    padding: 0 0 20px 0;
    position: relative !important;
    background: rgba(243, 246, 250, 1);
    .content {
      // padding: 66px 30px 20px 30px;
      padding: 66px 30px 0px 30px;
    }
  }
</style>
